function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M70 140c38.58 0 69.87-31.209 70-69.758v-.484C139.87 31.21 108.58 0 70 0 31.34 0 0 31.34 0 70s31.34 70 70 70z",
  fill: "#FFF6D9"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M70 140c38.58 0 69.87-31.209 70-69.758v-.484C139.87 31.21 108.58 0 70 0 31.34 0 0 31.34 0 70s31.34 70 70 70z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#magnifier-search-yellow_svg__a)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M123.394 143.632c0 29.62-23.93 53.632-53.447 53.632-29.519 0-53.447-24.012-53.447-53.632C16.5 114.012 40.428 90 69.947 90c29.517 0 53.447 24.012 53.447 53.632z",
  fill: "#002F34"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.752 62.498c0 22.728-18.19 41.153-40.626 41.153-22.437 0-40.626-18.425-40.626-41.153 0-22.729 18.189-41.154 40.626-41.154 22.437 0 40.626 18.425 40.626 41.154z",
  fill: "#FFCE32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.083 66.466a4.574 4.574 0 01-4.566 4.582 4.574 4.574 0 01-4.566-4.582 4.574 4.574 0 014.566-4.582c2.522 0 4.566 2.052 4.566 4.582zM32.827 54.797c15.567 4.082 31.426-4.274 37.327-18.955 3.564 10.742 13.585 18.48 25.39 18.48 4.92 0 9.531-1.345 13.493-3.69-5.028-16.945-20.547-29.288-38.911-29.288-19.576 0-35.918 14.026-39.768 32.698.806.283 1.63.535 2.47.755z",
  fill: "#002F34"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.33 16.26c0 8.982-7.254 16.262-16.204 16.262-8.95 0-16.206-7.28-16.206-16.261C53.92 7.28 61.176 0 70.126 0S86.33 7.28 86.33 16.26z",
  fill: "#002F34"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M109.828 125.791l2.948-6.994.645-1.531-10.403-25.793-12.085 4.908 10.404 25.793 3.545 1.509 4.946 2.108z",
  fill: "#D2B982"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.385 59.771c6.073 14.883-1.167 31.832-16.17 37.856-15.004 6.024-32.09-1.158-38.163-16.041C54.98 66.703 62.22 49.755 77.223 43.73c15.004-6.024 32.09 1.157 38.162 16.04z",
  fill: "#D2B982"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.024 53.46c9.574 8.075 10.736 22.32 2.596 31.816-8.14 9.497-22.5 10.65-32.073 2.575-9.573-8.074-10.736-22.319-2.596-31.815 8.14-9.497 22.5-10.65 32.073-2.575z",
  fill: "#FFEDB2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.872 70.638c0 5.406-4.382 9.787-9.787 9.787a9.786 9.786 0 01-9.787-9.787c0-5.405 4.381-9.787 9.787-9.787 5.405 0 9.787 4.382 9.787 9.787z",
  fill: "#002F34"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.312 122.159c0-8.038 6.494-14.554 14.504-14.554s14.503 6.516 14.503 14.554-6.493 14.554-14.503 14.554-14.504-6.516-14.504-14.554z",
  fill: "#FFCE32"
})));

const SvgMagnifierSearchYellow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 140,
  height: 140,
  fill: "none"
}, props), _ref, /*#__PURE__*/React.createElement("mask", {
  id: "magnifier-search-yellow_svg__a",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 140,
  height: 140
}, _ref2), _ref3);

export default SvgMagnifierSearchYellow;